import { z } from 'zod'

import { GetUserSchema } from './user'

export const GetDocumentTypeEnum = z.enum([
  'commercial_invoice',
  'export_import_documentation',
  'customs_other',
  'packing_list',
  'custom',
  'invoice',
  'other',
  'photo',
  'pod',
] as const)

export const GetMediaSchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  url: z.string().optional(),
})

export const GetDocumentSchema = z.object({
  created_at: z.coerce.date(),
  file: z.string().optional(),
  id: z.number(),
  type: GetDocumentTypeEnum,
  user: GetUserSchema,
})

export const GetUnassignedDocumentSchema = z.object({
  created_at: z.string(),
  file: z.instanceof(File),
  id: z.number(),
  media: GetMediaSchema, //remove it
  type: GetDocumentTypeEnum,
})

export const CreateDocumentSchema = z.object({
  error: z
    .object({
      message: z.string(),
    })
    .nullish(),
  file: z.instanceof(File),
  id: z.number().nullish(),
  status: z.enum(['done', 'error', 'pending']).nullish(),
  type: GetDocumentTypeEnum.optional(),
})

export type CreateDocument = z.infer<typeof CreateDocumentSchema>
export type DocumentTypes = z.infer<typeof GetDocumentTypeEnum>
export type GetDocument = z.infer<typeof GetDocumentSchema>
export type GetUnassignedDocument = z.infer<typeof GetUnassignedDocumentSchema>
